module.exports = __webpack_public_path__ + "img/GS_Profile-Kea Tsoai.a090745b.png";